var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 94,
    height: 94,
    rx: 23,
    fill: "url(#paint0_linear_171_226)",
    fillOpacity: 0.2,
    stroke: "url(#paint1_linear_171_226)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3333 33.3337C57.0383 33.3337 57.8908 33.3337 58.5902 33.5211C60.4882 34.0296 61.9707 35.5121 62.4793 37.4102C62.6667 38.1096 62.6667 38.962 62.6667 40.667V57.5337C62.6667 60.6139 62.6667 62.1541 62.0672 63.3306C61.5399 64.3655 60.6985 65.2069 59.6636 65.7342C58.4871 66.3337 56.947 66.3337 53.8667 66.3337H42.1333C39.053 66.3337 37.5129 66.3337 36.3364 65.7342C35.3015 65.2069 34.4601 64.3655 33.9328 63.3306C33.3333 62.1541 33.3333 60.6139 33.3333 57.5337V40.667C33.3333 38.962 33.3333 38.1096 33.5207 37.4102C34.0293 35.5121 35.5118 34.0296 37.4098 33.5211C38.1092 33.3337 38.9617 33.3337 40.6667 33.3337M42.5 53.5003L46.1667 57.167L54.4167 48.917M43.6 37.0003H52.4C53.4268 37.0003 53.9401 37.0003 54.3323 36.8005C54.6773 36.6247 54.9577 36.3443 55.1335 35.9993C55.3333 35.6071 55.3333 35.0938 55.3333 34.067V32.6003C55.3333 31.5736 55.3333 31.0602 55.1335 30.668C54.9577 30.323 54.6773 30.0426 54.3323 29.8668C53.9401 29.667 53.4268 29.667 52.4 29.667H43.6C42.5732 29.667 42.0599 29.667 41.6677 29.8668C41.3227 30.0426 41.0423 30.323 40.8665 30.668C40.6667 31.0602 40.6667 31.5736 40.6667 32.6003V34.067C40.6667 35.0938 40.6667 35.6071 40.8665 35.9993C41.0423 36.3443 41.3227 36.6247 41.6677 36.8005C42.0599 37.0003 42.5732 37.0003 43.6 37.0003Z",
    stroke: "#3D40D5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_171_226",
    x1: 0,
    y1: 0,
    x2: 96,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2319B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_171_226",
    x1: 98,
    y1: 30.5,
    x2: -2,
    y2: 81.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE25EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00568F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.4e121bd0bbdb120d6a1f42135fc09d51.svg";
export { ForwardRef as ReactComponent };